import { camelCase } from '@corp/helpers/string'

// TODO: Create a vite plugin to generate an even more optimized output.
const allIcons = Object.fromEntries(
  Object.entries(import.meta.glob('./**/*.svg', { import: 'default', eager: true }))
    .map(([path, url]) => [path.slice(2, -4).replace(/(regular|other)\//, ''), url as string]),
)

const iconAliases: Record<string, string> = {
  add: 'plus',
  catalog: 'gift-card',
  enable: 'valid',
  externalLink: 'external-link',
  FAQs: 'help',
  featured: 'solid/star',
  giftDesigns: 'gift-card',
  greetingCards: 'gift-card',
  legacyOrders: 'archive',
  organization: 'organizations',
  orderDrafts: 'orders',
  invalid: 'solid/delete-circle',
  remove: 'delete',
  retry: 'repeat',
  support: 'help',
  transactions: 'billing',
  view: 'show',
  Articles: 'help',
  'Help Articles': 'help',
}

// Public: Return the URL for an svg image corresponding to the given name.
export function urlForIcon (name: string) {
  const iconUrl = allIcons[name] || allIcons[toIconName(name)]

  if (!iconUrl) throw new TypeError(`Icon '${name}' is not defined.`)

  return iconUrl
}

export function toIconName (label: string) {
  const name = camelCase(label)
  return iconAliases[label] || iconAliases[name] || name
}
